import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";

import Factory1 from "../../assets/CarBusiness/부품공장.png";

const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"자동차판매사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <div className="kor">자동차사업</div>
              <div className="eng">Car Business</div>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"320px"}>
            <S.NavItem>
              <Link to="/CarBusiness/Sales">
                <div className="kor">A/S 부품 사업</div>
                <div className="eng">After-Sales (A/S) Parts Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/introduce">
                              <div className="kor">자동차사업</div>
                              <div className="eng">Car Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/Sales">
                              <div className="kor">자동차 판매사업</div>
                              <div className="eng">Automotive Sales Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsService">
                              <div className="kor">AS정비사업</div>
                              <div className="eng">AS maintenance business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/RentalService">
                              <div className="kor">렌터카 사업</div>
                              <div className="eng">Vehicle Rental Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/AsParts">
                              <div className="kor">A/S 부품 사업</div>
                              <div className="eng">After-Sales (A/S) Parts Business</div>
                            </Link>
                          </S.NavItem>
                          <S.NavItem className="list-inner-item">
                            <Link to="/CarBusiness/CarBusinessHistory">
                              <div className="kor">자동차사업이력</div>
                              <div className="eng">Major business history</div>
                            </Link>
                          </S.NavItem>
                        </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"A/S 부품 사업"} titleeng={"After-Sales (A/S) Parts Business"} />

            <div className="page-text">
                <div className="kor"><h2>한국에서 운행중인 약 2만여대 자일대우버스 부품 공급을 위해 전국 55개 대리점을 운영 </h2></div>
                <div className="eng"><h2>Operating 55 dealerships nationwide to supply parts for approximately
   20,000 Zile Daewoo buses in operation across Korea
</h2></div>
            </div>

             <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">A/S 부품 공장</div>
                <div className="eng">A/S Parts Plant</div>
              </div>
            </S.ImgHolderFullsize>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
